/**
 * Shadow tokens
 *
 * @module @smoothie-framework/ui-core/tokens
 */
export const shadows = Object.freeze({
    none: 'none',
    xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
});
const SHADOW_TOKEN_SET = new Set(Object.keys(shadows));
export function isShadowToken(value) {
    return SHADOW_TOKEN_SET.has(value);
}
export const SHADOW_TOKEN_KEYS = Object.freeze(Array.from(SHADOW_TOKEN_SET).sort());
//# sourceMappingURL=shadows.js.map